
import * as moment from 'moment';

export class Fechas {

  constructor() {
  }

  /**
   * Formatear fecha yyyy-mm-dd
   */
  formatDate(date) {
    const mes = date.getMonth() + 1; // Ya que los meses los cuenta desde el 0
    const dia = date.getDate();
    const hora = date.getHours();
    const minutos = date.getMinutes();
    const segundos = date.getSeconds();
    return `${(dia < 10 ? '0' : '').concat(dia)}/${(mes < 10 ? '0' : '').concat(mes)}/${date.getFullYear()} ${(hora < 10 ? '0' : '').concat(hora)}:${(minutos < 10 ? '0' : '').concat(minutos)}:${(segundos < 10 ? '0' : '').concat(segundos)}`;
  }

  /**
   * Formatear fecha yyyy-mm-dd
   */
  formatDateTwo(date) {
    const mes = date.getMonth() + 1; // Ya que los meses los cuenta desde el 0
    const dia = date.getDate();
    return `${(dia < 10 ? '0' : '').concat(dia)}/${(mes < 10 ? '0' : '').concat(mes)}/${date.getFullYear()}`;
  }

  getValidData(e, date1: Date, date2: Date, msg) {
    if (date1 !== null && date2 !== null) {
      if (date1 > date2) {
        e.setErrors({ 'incorrect': true, message: msg });
      }
    }
  }

  public getFechaFin(fechaValidar: Date, edad: number): Date {
    let dateModifi = new Date();
    dateModifi.setDate(new Date(fechaValidar).getDate());
    dateModifi.setMonth(new Date(fechaValidar).getMonth());
    dateModifi.setFullYear(fechaValidar.getFullYear() + edad);
    return dateModifi;
  }

  calcDate(date1, date2): boolean {
    let mayor = false;
    const years = moment().diff(date1, 'years');

    if (years > 18) {
      mayor = true;
    } else if (years === 18) {
      const mes = date2.getMonth() - date1.getMonth();
      if (mes < 0) {
        mayor = true;
      } else if (mes === 0) {
        const dia = date2.getDate() - date1.getDate();
        if (dia <= 0) {
          mayor = true;
        }
      }
    }
    return mayor;
  }

  formatoFecha(texto) {
    if (!this.validarFormatoFecha(texto)) {
      return texto.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
    }
    return texto;
  }

  validarFormatoFecha(campo) {
    var RegExPattern = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;
    if ((campo.match(RegExPattern)) && (campo != '')) {
      return true;
    } else {
      return false;
    }
  }
}

export const CALENDARIO_ESPANOL: any = {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    today: 'Hoy',
    clear: 'Borrar',
    dateFormat: 'dd.mm.yy',
  };
